
import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

const BreadCrumbs = ({pageState}) => (pageState.breadCrumbs.length === 0)?<></>:
<Breadcrumb>
    {pageState.breadCrumbs.map((crumb, i) =>
       <Breadcrumb.Item key={i} active={crumb.isActive} onClick={crumb.callback} >{crumb.text}</Breadcrumb.Item> 
    )}
</Breadcrumb>;

export default BreadCrumbs;